<h2>Tabs Component - Todas las Opciones</h2>
<p class="section-description">
	El componente de tabs soporta 3 tipos visuales diferentes, 4 tamaños, y opciones de iconOnly y fitContent.
</p>

<!-- TYPE 1: Underline Style -->
<section class="ui-section">
	<h3>Type 1 - Underline Style (Texto con subrayado)</h3>
	<p>Estilo clásico con distribución de ancho completo e indicador de subrayado.</p>

	<div class="tabs-grid">
		<div class="tabs-column">
			<span class="label">Type 1 - Texto solo (Large)</span>
			<app-tabs
				[tabHeaders]="textOnlyTabs"
				type="type1"
				size="large"
				[selectedTab]="selectedTabType1"
				(selectedTabChange)="onTabChangeType1($event)">
			</app-tabs>
			<app-ui-code-block [code]="generateCode({tabHeaders: 'textOnlyTabs', type: 'type1', size: 'large', selectedTab: 'selectedTab', selectedTabChange: 'onTabChange($event)'})" />
		</div>

		<div class="tabs-column">
			<span class="label">Type 1 - Texto solo (Medium)</span>
			<app-tabs
				[tabHeaders]="textOnlyTabs"
				type="type1"
				size="medium"
				[selectedTab]="selectedTabType1"
				(selectedTabChange)="onTabChangeType1($event)">
			</app-tabs>
			<app-ui-code-block [code]="generateCode({tabHeaders: 'textOnlyTabs', type: 'type1', size: 'medium', selectedTab: 'selectedTab', selectedTabChange: 'onTabChange($event)'})" />
		</div>

		<div class="tabs-column">
			<span class="label">Type 1 - Texto solo (Small)</span>
			<app-tabs
				[tabHeaders]="textOnlyTabs"
				type="type1"
				size="small"
				[selectedTab]="selectedTabType1"
				(selectedTabChange)="onTabChangeType1($event)">
			</app-tabs>
			<app-ui-code-block [code]="generateCode({tabHeaders: 'textOnlyTabs', type: 'type1', size: 'small', selectedTab: 'selectedTab', selectedTabChange: 'onTabChange($event)'})" />
		</div>

		<div class="tabs-column">
			<span class="label">Type 1 - Icon Only (Large)</span>
			<app-tabs
				[tabHeaders]="iconOnlyTabs"
				type="type1"
				size="large"
				[iconOnly]="true"
				[selectedTab]="selectedTabType1IconOnly"
				(selectedTabChange)="onTabChangeType1IconOnly($event)">
			</app-tabs>
			<app-ui-code-block [code]="generateCode({tabHeaders: 'iconOnlyTabs', type: 'type1', size: 'large', iconOnly: true, selectedTab: 'selectedTab', selectedTabChange: 'onTabChange($event)'})" />
		</div>
	</div>
</section>

<!-- TYPE 2: Pill Style -->
<section class="ui-section">
	<h3>Type 2 - Pill Style (Píldoras con iconos)</h3>
	<p>Estilo moderno con iconos, fondo redondeado y diseño profesional.</p>

	<h4>Todos los Tamaños - Con Iconos y Texto</h4>
	<div class="size-grid">
		<div class="size-column">
			<span class="label">Large (64px)</span>
			<app-tabs
				[tabHeaders]="iconTabs"
				type="type2"
				size="large"
				[selectedTab]="selectedTabType2Large"
				(selectedTabChange)="onTabChangeType2Large($event)">
			</app-tabs>
			<app-ui-code-block [code]="generateCode({tabHeaders: 'iconTabs', type: 'type2', size: 'large', selectedTab: 'selectedTab', selectedTabChange: 'onTabChange($event)'})" />
		</div>

		<div class="size-column">
			<span class="label">Medium (56px)</span>
			<app-tabs
				[tabHeaders]="iconTabs"
				type="type2"
				size="medium"
				[selectedTab]="selectedTabType2Medium"
				(selectedTabChange)="onTabChangeType2Medium($event)">
			</app-tabs>
			<app-ui-code-block [code]="generateCode({tabHeaders: 'iconTabs', type: 'type2', size: 'medium', selectedTab: 'selectedTab', selectedTabChange: 'onTabChange($event)'})" />
		</div>

		<div class="size-column">
			<span class="label">Small (48px)</span>
			<app-tabs
				[tabHeaders]="iconTabs"
				type="type2"
				size="small"
				[selectedTab]="selectedTabType2Small"
				(selectedTabChange)="onTabChangeType2Small($event)">
			</app-tabs>
			<app-ui-code-block [code]="generateCode({tabHeaders: 'iconTabs', type: 'type2', size: 'small', selectedTab: 'selectedTab', selectedTabChange: 'onTabChange($event)'})" />
		</div>

		<div class="size-column">
			<span class="label">XSmall (32px)</span>
			<app-tabs
				[tabHeaders]="iconTabs"
				type="type2"
				size="xsmall"
				[selectedTab]="selectedTabType2XSmall"
				(selectedTabChange)="onTabChangeType2XSmall($event)">
			</app-tabs>
			<app-ui-code-block [code]="generateCode({tabHeaders: 'iconTabs', type: 'type2', size: 'xsmall', selectedTab: 'selectedTab', selectedTabChange: 'onTabChange($event)'})" />
		</div>
	</div>

	<h4>Icon Only - Todos los Tamaños</h4>
	<div class="size-grid">
		<div class="size-column">
			<span class="label">Large (48x48px)</span>
			<app-tabs
				[tabHeaders]="iconOnlyTabs"
				type="type2"
				size="large"
				[iconOnly]="true"
				[selectedTab]="selectedTabType2IconOnlyLarge"
				(selectedTabChange)="onTabChangeType2IconOnlyLarge($event)">
			</app-tabs>
			<app-ui-code-block [code]="generateCode({tabHeaders: 'iconOnlyTabs', type: 'type2', size: 'large', iconOnly: true, selectedTab: 'selectedTab', selectedTabChange: 'onTabChange($event)'})" />
		</div>

		<div class="size-column">
			<span class="label">Medium (40x40px)</span>
			<app-tabs
				[tabHeaders]="iconOnlyTabs"
				type="type2"
				size="medium"
				[iconOnly]="true"
				[selectedTab]="selectedTabType2IconOnlyMedium"
				(selectedTabChange)="onTabChangeType2IconOnlyMedium($event)">
			</app-tabs>
			<app-ui-code-block [code]="generateCode({tabHeaders: 'iconOnlyTabs', type: 'type2', size: 'medium', iconOnly: true, selectedTab: 'selectedTab', selectedTabChange: 'onTabChange($event)'})" />
		</div>

		<div class="size-column">
			<span class="label">Small (32x32px)</span>
			<app-tabs
				[tabHeaders]="iconOnlyTabs"
				type="type2"
				size="small"
				[iconOnly]="true"
				[selectedTab]="selectedTabType2IconOnlySmall"
				(selectedTabChange)="onTabChangeType2IconOnlySmall($event)">
			</app-tabs>
			<app-ui-code-block [code]="generateCode({tabHeaders: 'iconOnlyTabs', type: 'type2', size: 'small', iconOnly: true, selectedTab: 'selectedTab', selectedTabChange: 'onTabChange($event)'})" />
		</div>

		<div class="size-column">
			<span class="label">XSmall (24x24px)</span>
			<app-tabs
				[tabHeaders]="iconOnlyTabs"
				type="type2"
				size="xsmall"
				[iconOnly]="true"
				[selectedTab]="selectedTabType2IconOnlyXSmall"
				(selectedTabChange)="onTabChangeType2IconOnlyXSmall($event)">
			</app-tabs>
			<app-ui-code-block [code]="generateCode({tabHeaders: 'iconOnlyTabs', type: 'type2', size: 'xsmall', iconOnly: true, selectedTab: 'selectedTab', selectedTabChange: 'onTabChange($event)'})" />
		</div>
	</div>
</section>

<!-- TYPE 3: Flag Style -->
<section class="ui-section">
	<h3>Type 3 - Flag Style (Estilo bandera)</h3>
	<p>Estilo especial para selección de país/región con banderas o imágenes.</p>

	<h4>Todos los Tamaños - Con Imágenes y Texto</h4>
	<div class="size-grid">
		<div class="size-column">
			<span class="label">Large (64px)</span>
			<app-tabs
				[tabHeaders]="companyTabs"
				type="type3"
				size="large"
				[selectedTab]="selectedTabType3Large"
				(selectedTabChange)="onTabChangeType3Large($event)">
			</app-tabs>
			<app-ui-code-block [code]="generateCode({tabHeaders: 'companyTabs', type: 'type3', size: 'large', selectedTab: 'selectedTab', selectedTabChange: 'onTabChange($event)'})" />
		</div>

		<div class="size-column">
			<span class="label">Medium (56px)</span>
			<app-tabs
				[tabHeaders]="companyTabs"
				type="type3"
				size="medium"
				[selectedTab]="selectedTabType3Medium"
				(selectedTabChange)="onTabChangeType3Medium($event)">
			</app-tabs>
			<app-ui-code-block [code]="generateCode({tabHeaders: 'companyTabs', type: 'type3', size: 'medium', selectedTab: 'selectedTab', selectedTabChange: 'onTabChange($event)'})" />
		</div>

		<div class="size-column">
			<span class="label">Small (48px)</span>
			<app-tabs
				[tabHeaders]="companyTabs"
				type="type3"
				size="small"
				[selectedTab]="selectedTabType3Small"
				(selectedTabChange)="onTabChangeType3Small($event)">
			</app-tabs>
			<app-ui-code-block [code]="generateCode({tabHeaders: 'companyTabs', type: 'type3', size: 'small', selectedTab: 'selectedTab', selectedTabChange: 'onTabChange($event)'})" />
		</div>

		<div class="size-column">
			<span class="label">XSmall (32px)</span>
			<app-tabs
				[tabHeaders]="companyTabs"
				type="type3"
				size="xsmall"
				[selectedTab]="selectedTabType3XSmall"
				(selectedTabChange)="onTabChangeType3XSmall($event)">
			</app-tabs>
			<app-ui-code-block [code]="generateCode({tabHeaders: 'companyTabs', type: 'type3', size: 'xsmall', selectedTab: 'selectedTab', selectedTabChange: 'onTabChange($event)'})" />
		</div>
	</div>

	<h4>Icon Only</h4>
	<div class="tabs-grid">
		<div class="tabs-column">
			<span class="label">Type 3 - Icon Only</span>
			<app-tabs
				[tabHeaders]="iconOnlyTabs"
				type="type3"
				size="large"
				[iconOnly]="true"
				[selectedTab]="selectedTabType3IconOnly"
				(selectedTabChange)="onTabChangeType3IconOnly($event)">
			</app-tabs>
			<app-ui-code-block [code]="generateCode({tabHeaders: 'iconOnlyTabs', type: 'type3', size: 'large', iconOnly: true, selectedTab: 'selectedTab', selectedTabChange: 'onTabChange($event)'})" />
		</div>
	</div>
</section>

<!-- Fit Content Option -->
<section class="ui-section">
	<h3>Opción Fit Content</h3>
	<p>Controla si las tabs se distribuyen equitativamente o se ajustan al ancho de su contenido.</p>

	<div class="tabs-grid">
		<div class="tabs-column">
			<span class="label">Default (Distribución Equitativa)</span>
			<app-tabs
				[tabHeaders]="fitContentTabs"
				type="type3"
				size="large"
				[fitContent]="false"
				[selectedTab]="selectedTabFitDefault"
				(selectedTabChange)="onTabChangeFitDefault($event)">
			</app-tabs>
			<app-ui-code-block [code]="generateCode({tabHeaders: 'fitContentTabs', type: 'type3', size: 'large', fitContent: false, selectedTab: 'selectedTab', selectedTabChange: 'onTabChange($event)'})" />
		</div>

		<div class="tabs-column">
			<span class="label">Fit Content (Ancho del Contenido)</span>
			<app-tabs
				[tabHeaders]="fitContentTabs"
				type="type3"
				size="large"
				[fitContent]="true"
				[selectedTab]="selectedTabFitContent"
				(selectedTabChange)="onTabChangeFitContent($event)">
			</app-tabs>
			<app-ui-code-block [code]="generateCode({tabHeaders: 'fitContentTabs', type: 'type3', size: 'large', fitContent: true, selectedTab: 'selectedTab', selectedTabChange: 'onTabChange($event)'})" />
		</div>
	</div>
</section>

<!-- Data Structure -->
<section class="ui-section">
	<h3>Estructura de Datos</h3>
	<div class="data-structure">
		<app-ui-code-block [code]="generateTabDataStructure()" />
		<p class="note">
			<strong>Notas importantes:</strong>
		</p>
		<ul class="notes-list">
			<li>Los iconos pueden ser rutas de imágenes (PNG, SVG) o nombres de iconos Lucide.</li>
			<li><strong>iconOnly:</strong> Establece <code>[iconOnly]="true"</code> en cualquier tipo de tab para ocultar las etiquetas. Las etiquetas se ocultan visualmente pero se usan para aria-labels para accesibilidad.</li>
			<li><strong>fitContent:</strong> Establece <code>[fitContent]="true"</code> para que las tabs se ajusten al ancho de su contenido en lugar de distribución equitativa.</li>
			<li><strong>Tipos disponibles:</strong> type1 (Underline), type2 (Pill), type3 (Flag)</li>
			<li><strong>Tamaños disponibles:</strong> large, medium, small, xsmall</li>
		</ul>
	</div>
</section>
